import { cloudCode } from ".";

export function cancelDevicePairing(pairingRequestId: string) {
  return cloudCode.run("cancelDevicePairing", {
    pairingRequestId,
  });
}
